import { CircleCheck, CircleAlert, CircleX } from "lucide-react";

const alertVariants = {
  success: {
    class: "text-green-800 bg-green-100 border border-green-300",
    icon: <CircleCheck className="w-5 h-5 shrink-0" aria-hidden="true" />,
  },
  danger: {
    class: "text-danger-dark bg-danger-light border-none",
    icon: <CircleAlert className="w-5 h-5 shrink-0" aria-hidden="true" />,
  },

  warning: {
    class: "text-alert-dark bg-alert-light border-none",
    icon: <CircleX className="w-5 h-5 shrink-0" aria-hidden="true" />,
  },
};

function Alert({ text = "", intent = "success", fullWidth = false, visible }) {
  const width = fullWidth
    ? "w-full min-w-0"
    : "w-full max-w-md sm:max-w-2xl";
  const baseStyles = `flex min-h-12 pl-3 pr-3 py-2.5 rounded-lg text-sm sm:text-base items-start sm:items-center shadow-lg ${width}`;

  return (
    <div
      role="alert"
      aria-live="polite"
      className={`${baseStyles} ${alertVariants[intent]["class"]} ${
        visible ? "animate-enter" : "animate-leave"
      }`}
    >
      <div className="mt-0.5 sm:mt-0">{alertVariants[intent]["icon"]}</div>
      <span className="pl-2 break-words leading-snug">{text}</span>
    </div>
  );
}

export default Alert;
